import { render } from "./OssFile.vue?vue&type=template&id=70dafac6&scoped=true"
import script from "./OssFile.vue?vue&type=script&lang=js"
export * from "./OssFile.vue?vue&type=script&lang=js"

import "./OssFile.vue?vue&type=style&index=0&id=70dafac6&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dafac6"]])

export default __exports__